
export class PredefinedBaseConfiguration {
exitStatusOnFailure: boolean | null;
}

